import { trackOperation, trackOperationFailureIfAuthed } from 'events/ops/opsEvent';
import { logToServer } from 'middleware/logger';

/**
 * Wraps a heartProduct dispatch to emit SaveToFavorites ops events.
 *
 * heartProduct's internal .catch swallows rejections and resolves with
 * dispatch(toggleHeartingLoginModal(...)) — a plain action object — after
 * cleanup. On success (200), the promise resolves with undefined.
 * We use the resolved value to distinguish success from caught failure.
 *
 * When the user is unrecognized, dispatch(heartProduct(...)) returns a
 * plain action (login modal) rather than a Promise — we skip tracking.
 */
export function trackableHeartProduct(dispatch: Function, heartProductAction: Function, args: object, callback?: Function) {
  const result = dispatch(heartProductAction(args, callback));

  // heartProduct returns a Promise only for recognized users.
  // Unrecognized users get a plain Redux action (login modal) — skip tracking.
  if (result && typeof result.then === 'function') {
    result.then((resolved: unknown) => {
      if (resolved === undefined) {
        trackOperation('SaveToFavorites', 'success');
      } else {
        const action = resolved as { error?: { status?: number } };
        logToServer(`[SaveToFavorites] failure - status code: ${action.error?.status || 'no status'}`);
        trackOperationFailureIfAuthed('SaveToFavorites', action.error?.status);
      }
    });
  }
}
